import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { get, map, trim, escape, filter, isNil } from 'lodash';
import { _get } from '../../utils/misc';
import MutationManager from './Mutation';

/**
 * [UPDATE_PICKERS] Example Input
 * {
  "id":"rsuez93@gmail.com",
    "pickerInput": {
    "firstName": "Ronald",
    "lastName": "Suez",
    "email": "rsuez93@gmail.com",
    "status": "1",
    "pickerType": "0",
    "role": "1",
    "phone": "1234456"
    }
  }
 */

const UPDATE_PICKERS = gql`
  mutation updatePicker($id: String!, $payload: PickerInput) {
    updatePicker(id: $id, input: $payload) {
      id
      email
      updatedAt
      repeatedRut
    }
  }
`

const updatePayload = ({ id, payload }) => {
  const { firstName, lastName, document, phone, switchAutoSala } = payload
  const _id = trim(escape(id))
  const status = String(_get(payload, 'status', '4'))
  const statusUser = get(payload, 'statusUser.value')
  const groups = map(filter(get(payload, 'profiles'), element => !isNil(get(element, 'value'))), ({ value }) => value);
  const company = get(payload, 'company.value')
  const typeUser = get(payload, 'typeUser.value')
  const salesChannelInfo = get(payload, 'salesChannels')
  const splitUser = get(payload, 'splitUser')

  const reqPayload = {
    refetchQueries: () => ['getUserPickers', 'getUsersFeed', 'getUserSessionInfo'],
    variables: {
      id: _id,
      payload: {
        phone,
        firstName,
        lastName,
        document,
        status,
        statusUser,
        typeUser,
        company,
        groups,
        salesChannelInfo,
        switchAutoSala,
        splitUser
      }
    }
  }

  return reqPayload
}

const UpdatePickers = ({ children, ...props }) => {
  return (
    <MutationManager mutation={UPDATE_PICKERS} refetchQueries={['getUserPickers', 'getUsersFeed', 'getUserSessionInfo']} {...props}>
      {({ data, loading, updateFn }) => children({ updateFn: (values) => (updateFn(updatePayload(values))), loading, ...props })}
    </MutationManager>
  )
}

UpdatePickers.propTypes = {
  children: PropTypes.any
}

export default UpdatePickers;

export {
  UPDATE_PICKERS
};
